import React, { memo } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
    Label,
    Form,
    FormGroup,
    Row,
} from 'reactstrap';
import IntlMessages from '../../../helpers/IntlMessages';
import PerfectScrollbar from 'react-perfect-scrollbar';
import DynamicForm from '../general/DynamicForm';
import Creatable from '../../../components/common/CreatableSelect';
import { Colxx } from '../../../components/common/CustomBootstrap';
import { AddCommaNumber } from '../../../helpers/Utils';

const ContentComponent = ({
    title,
    isOpen,
    toggle,
    onSubmit,
    children,
    data_dynamic_form,
    values,
    onChange,
    setting,
    onChangeDynamicForm,
    data_stocks,
}) => {
    // console.log('render AddComponent');
    let items_select = [];
    items_select = data_stocks.map(item => ({
        label: item.name, // Hiển thị tên sản phẩm cho người dùng
        value: item.name, // Giá trị khi chọn cũng là tên sản phẩm
        // ...item           // Thêm tất cả các thuộc tính khác của item vào option
    }));

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            wrapClassName='modal-right'
            backdrop={true}
            autoFocus={false}
        >
            <Form onSubmit={(e) => onSubmit(e)}>
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody className='scrool modal-right-add'>
                    <PerfectScrollbar
                        options={{
                            suppressScrollX: true,
                            wheelPropagation: false,
                        }}
                        id='modal-right__body'
                    >
                        {/* {children} */}
                        <FormGroup className='mt-3 has-float-label'>
                            <Label for='name' className='text-muted'>
                                <IntlMessages id='company-provider.name' /><span style={{color: 'red'}}>*</span>
                            </Label>
                            <Input
                                autoFocus={true}
                                type='text'
                                name='name'
                                id='name'
                                disabled={setting.viewonly && !setting.add}
                                value={values.name}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='phone' className='text-muted'>
                                <IntlMessages id='phone' /><span style={{color: 'red'}}>*</span>
                            </Label>
                            <Input
                                type='text'
                                name='phone'
                                id='phone'
                                disabled={setting.viewonly && !setting.add}
                                value={values.phone}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='email' className='text-muted'>
                                <IntlMessages id='email' />
                            </Label>
                            <Input
                                type='email'
                                name='email'
                                id='email'
                                disabled={setting.viewonly && !setting.add}
                                value={values.email}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='address' className='text-muted'>
                                <IntlMessages id='address' /><span style={{color: 'red'}}>*</span>
                            </Label>
                            <Input
                                type='text'
                                name='address'
                                id='address'
                                disabled={setting.viewonly && !setting.add}
                                value={values.address}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='tax_code' className='text-muted'>
                                Mã số thuế
                            </Label>
                            <Input
                                type='text'
                                name='tax_code'
                                id='tax_code'
                                placeholder='Ví dụ: 0101234567'
                                disabled={setting.viewonly && !setting.add}
                                value={values.tax_code || ''}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='notes' className='text-muted'>
                                Ghi chú
                            </Label>
                            <Input
                                type='textarea'
                                rows='2'
                                name='notes'
                                id='notes'
                                placeholder='Ghi chú thông tin nhà cung cấp...'
                                disabled={setting.viewonly && !setting.add}
                                value={values.notes || ''}
                                onChange={onChange}



                            />
                        </FormGroup>
                        <FormGroup className='mt-3 has-float-label'>
                          <Label for='item_name' className='text-muted'>
                              <IntlMessages id='company-provider.item_name' />
                          </Label>
                          <Creatable
                            isMulti
                            // className={'react-select-creatable'}
                            placeholder={'Chọn hoặc tạo mới mặt hàng cung cấp'}
                            name='items_selected'
                            id='items_selected'
                            onChange={(val) =>
                                onChange(val, 'items_selected')
                            }
                            value={values.items_selected}
                            options={items_select}
                            formatCreateLabel={(inputValue) => `Tạo mới mặt hàng: "${inputValue}"`}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999 // Đảm bảo portal menu luôn ở trên cùng
                                })
                            }}
                          />
                        </FormGroup>
                        {values.items_selected && values.items_selected.length > 0 ? 
                          <>
                            <div className='d-flex justify-content-between align-items-center mb-2'>
                              <div className='mr-2 w-50 text-muted text-small'>Tên mặt hàng</div>
                              <div className='mr-2 w-25 text-muted text-small'>
                                Đơn giá
                              </div>
                              <div className='w-25 text-muted text-small'>
                                Số lượng
                              </div>
                            </div>
                            {values.items_selected.map((item, index) => (
                              <div className='d-flex justify-content-between align-items-center mb-2' key={item.value}>
                                <div className='mr-2 w-50'>{item.label}</div>
                                <div className='mr-2 w-25'>
                                  <Input
                                    type='text'
                                    name='price'
                                    id={`price-${index}`}
                                    value={AddCommaNumber(item.price) || ''}
                                    onChange={(e) => onChange(e, index)}
                                    className='custom-input-underline pad-2px'
                                  />
                                </div>
                                <div className='w-25'>
                                  <Input
                                    type='number'
                                    name='quantity'
                                    id={`quantity-${index}`}
                                    value={item.quantity || ''}
                                    onChange={(e) => onChange(e, index)}
                                    className='custom-input-underline pad-2px'
                                  />
                                </div>
                              </div>
                            ))} 
                          </>
                        : 
                        <>
                            <div className='d-flex justify-content-between align-items-center mb-2'>
                              <div className='mr-2 w-50 text-muted text-small'>Tên mặt hàng</div>
                              <div className='mr-2 w-25 text-muted text-small'>
                                Đơn giá
                              </div>
                              <div className='w-25 text-muted text-small'>
                                Số lượng
                              </div>
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-2'>
                                <div className='mr-2 w-50'>...</div>
                                <div className='mr-2 w-25'>
                                    <Input
                                    type='number'
                                    name='price'
                                    className='custom-input-underline pad-2px'
                                    />
                                </div>
                                <div className='w-25'>
                                    <Input
                                    type='number'
                                    name='quantity'
                                    className='custom-input-underline pad-2px'
                                    />
                                </div>
                            </div>
                        </>
                        }
                        <DynamicForm
                            values={values.dynamic_form}
                            data={data_dynamic_form}
                            onChange={onChangeDynamicForm}
                            disabled={setting.viewonly && !setting.add}
                        />
                    </PerfectScrollbar>
                </ModalBody>
                <ModalFooter>
                    <Button color='primary'>
                        <IntlMessages id='company-provider.btn-add' />
                    </Button>{' '}
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default memo(ContentComponent);
